import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { logOut } from "@/src/auth/store/auth-slice";
import { persistor, store } from "@/src/common/redux/store";
import { httpClient } from "@/src/common/services/http.service";

export async function performLogout(): Promise<void> {
	try {
		await httpClient.auth.logout.post();
	} catch {
		// Si le serveur ne répond pas, on déconnecte quand même côté client.
	}
	store.dispatch(logOut());
	await persistor.purge();
	window.location.href = AUTH_ROUTES.AUTH;
}
